module.exports = __webpack_public_path__ + "static/img/2.807f629.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/2020-1.31/2.jpg
// module id = AW/g
// module chunks = 1